// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sticker__container-cd62b8 {
  border: none;
  background-color: transparent;
  box-shadow: none;
  pointer-events: none;
  overflow: visible;
}

.Sticker__overlay-f61406 {
  pointer-events: none;
}

.Sticker__sticker-cbe788 {
  animation: Sticker__zoom-in-b5996a 0.2s ease;
  animation-fill-mode: forwards;
}

@keyframes Sticker__zoom-in-b5996a {
  0% {
    transform: scale(0.5, 0.5);
  }
  100% {
    transform: scale(1, 1);
  }
}
.Sticker__translateContainer-efdebd {
  pointer-events: none;
  animation: Sticker__translate-in-a893ed 0.2s linear;
  animation-fill-mode: forwards;
}

@keyframes Sticker__translate-in-a893ed {
  100% {
    transform: translate(0, 0);
  }
}`, "",{"version":3,"sources":["webpack://./src/main/Popups/GetParametersManager/Popups/Sticker/styles.m.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,6BAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,4CAAA;EACA,6BAAA;AACF;;AAEA;EACE;IACE,0BAAA;EACF;EACA;IACE,sBAAA;EACF;AACF;AAEA;EACE,oBAAA;EACA,mDAAA;EACA,6BAAA;AAAF;;AAGA;EACE;IACE,0BAAA;EAAF;AACF","sourcesContent":[".container {\n  border: none;\n  background-color: transparent;\n  box-shadow: none;\n  pointer-events: none;\n  overflow: visible;\n}\n\n.overlay {\n  pointer-events: none;\n}\n\n.sticker {\n  animation: zoom-in 0.2s ease;\n  animation-fill-mode: forwards;\n}\n\n@keyframes zoom-in {\n  0% {\n    transform: scale(0.5, 0.5);\n  }\n  100% {\n    transform: scale(1, 1);\n  }\n}\n\n.translateContainer {\n  pointer-events: none;\n  animation: translate-in 0.2s linear;\n  animation-fill-mode: forwards;\n}\n\n@keyframes translate-in {\n  100% {\n    transform: translate(0, 0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Sticker__container-cd62b8`,
	"overlay": `Sticker__overlay-f61406`,
	"sticker": `Sticker__sticker-cbe788`,
	"zoom-in": `Sticker__zoom-in-b5996a`,
	"zoomIn": `Sticker__zoom-in-b5996a`,
	"translateContainer": `Sticker__translateContainer-efdebd`,
	"translate-in": `Sticker__translate-in-a893ed`,
	"translateIn": `Sticker__translate-in-a893ed`
};
module.exports = ___CSS_LOADER_EXPORT___;
